import './account.css';
import { Link } from 'react-router-dom';
import { t } from '../../i18n';
import { useClientApp } from '../context';

// Teile der Übersicht, die zum Konto gehören: Hinweis zu Firmen in Prüfung und „Weitere Firma anmelden“.

// Eine Zeile je Firma, die noch geprüft wird oder nicht freigegeben wurde.
// Die Sitzung lädt die ganze App live neu (useSessionLive), eine freigegebene Firma erscheint also sofort als Firma.
export function PendingCompaniesNotice() {
  const { me } = useClientApp();
  const open = me.clients.filter((c) => c.status !== 'active');
  if (!open.length) return null;
  return (
    <div className="notice regnote" role="status">
      {open.map((c) => (
        <div className="nt-r" key={c.id}>
          <span className="nt-i" aria-hidden="true">
            {c.status === 'rejected' ? '✕' : '⏳'}
          </span>
          <div className="tx">
            <b>{c.name}</b>:{' '}
            {c.status === 'rejected'
              ? c.rejectReason
                ? t('Registrierung nicht freigegeben · „{reason}“', { reason: c.rejectReason })
                : t('Registrierung nicht freigegeben')
              : t('Registrierung in Prüfung')}
          </div>
        </div>
      ))}
    </div>
  );
}

export function AddCompanyLink() {
  return (
    <p className="addco">
      <Link to="/app/firma-anmelden">{t('Weitere Firma anmelden')}</Link>
    </p>
  );
}
